import { Track } from "../../AudioManager";
import { HTMLResource } from "../../ResourceManager/HTMLResource";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Size, SetStyles, Scale, Point } from "../.././MyHelpers";
import { BigWinCountAnimation } from "../BigWinCountAnimation";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { FreegameBonus2, FreegameBonus2Params, FreegameBonusFactory2 } from "./FreegameBonus2";
import { FreegameSession } from "./FreegameSession";
import { TweenLite, Power0, Elastic} from "gsap";
import { JackpotDisplayType, Settings } from "../../Settings";
import { FreegameBonusNoJackpot2_2Screen } from "./FreegameBonusNoJackpot2_2Screen";
import { FreegamesCommonConfiguration } from "../../api";
export  class FreegameBonus2_2Screen extends FreegameBonus2
{
	
	public constructor(gameResid: ResourceIdentifier, freegameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params) {
		super(gameResid, freegameConfig, params)
	}
	protected override createFreeGameStats(resourceManager : ResourceManager):void{
		super.createFreeGameStats(resourceManager);
		this.containerfreegameStats.style.transform="scale(0.6)";
		this.containerfreegameStats.style.justifyContent="flex-start";		
		this.containerfreegameStats.style.position="absolute";
		this.containerfreegameStats.style.width="65%";
		this.containerfreegameStats.style.left=Scale.Xpx(-158);
		this.containerfreegameStats.style.top = Scale.Ypx(710);
	}	
	
	public override GameTitleLoaded(resourceManager: IReadOnlyResourceManager){
		// super.GameTitleLoaded(resourceManager);
		// this.titleElement.style.justifyContent="flex-start";
		// this.titleGame = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(this.gameName).Add("title")).sprite, canvasSize: new Size(600, 400)});	
		// this.titleGame.DrawFirstFrame();
		// this.titleGame.Update();	
	}
	public override CreateFreeGameTitleSprite(resourceManager: ResourceManager): void {
		super.CreateFreeGameTitleSprite(resourceManager);
		this.titleFreeGameContainer.style.justifyContent ="flex-start";
		this.titleFreeGameContainer.style.position="absolute";
		this.titleFreeGameContainer.style.bottom=Scale.Ypx(270);
		this.titleFreeGameContainer.style.left=Scale.Xpx(60);
		this.freeGamesTitleSprite.SetSize(new Size(Scale.W(800),Scale.H(150)));
		this.freeGamesTitleSprite.DrawFirstFrame();
		this.freeGamesTitleSprite.Update();	
	}

	protected override ShowWin(session: FreegameSession) {
		super.ShowWin(session);
		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 0
			});
		}
	}

	protected override ResetShowWin(session: FreegameSession) {
		TweenLite.to(this.finalWinContainer, 2.5, {
			x: this.viewSize.Width, display: "none",
		});	
		//Stops Anims
		this.Stop();
		this.containerfreegameStats.style.display="flex";		
		if(this.titleFreeGameContainer != null)this.titleFreeGameContainer.style.display="flex";
		if (globalThis.jackpotDisplayGlobal != null) {
			globalThis.jackpotDisplayGlobal.View().style.opacity = "1";
		}
	}	
}
export class FreegameBonusFactory2_2screen extends FreegameBonusFactory2 
{
	public CreateFreegameBonus2_2Screen(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params): FreegameBonus2 
	{
		if(Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
		{
			return new FreegameBonus2_2Screen(gameName, freeGameConfig, params);
		}
		else
		{
			return new FreegameBonusNoJackpot2_2Screen(gameName, freeGameConfig, params);
		}		
	}	
}